import React, { useCallback, useState } from "react";
import { ClipboardCheck, Copy, Loader2 } from "lucide-react";
import useSiwsAdmin from "@/hooks/useSiwsAdmin";
import { toast } from "sonner";

export default function LaunchMigrationCard() {
  const { authFetch } = useSiwsAdmin();
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = useCallback(async () => {
    setBusy(true);
    try {
      const { data: d } = await authFetch("/admin/launch-migration", { method: "GET" });
      setData(d);
    } catch (e) {
      toast.error(e?.response?.data?.detail || e?.message || "Failed to load report");
    } finally {
      setBusy(false);
    }
  }, [authFetch]);

  const text = data ? JSON.stringify(data, null, 2) : "";
  const status = data?.migration?.status || "—";

  return (
    <div className="glass-card rounded-xl p-5" data-testid="admin-launch-migration-card">
      <div className="flex items-center justify-between gap-3 mb-3">
        <h3 className="text-sm font-bold uppercase tracking-widest text-[#00FFA3]" style={{ fontFamily: "Orbitron, sans-serif" }}>
          Launch Spec v1 · Migration Report
        </h3>
        <span className="text-[10px] font-mono text-slate-400" data-testid="launch-migration-status">status: {status}</span>
      </div>
      <div className="flex gap-2 mb-3">
        <button
          type="button"
          onClick={load}
          disabled={busy}
          data-testid="launch-migration-load-btn"
          className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-semibold bg-[#00FFA3]/10 border border-[#00FFA3]/30 text-[#00FFA3] hover:bg-[#00FFA3]/20 transition-colors disabled:opacity-50"
        >
          {busy ? <Loader2 size={12} className="animate-spin" /> : <ClipboardCheck size={12} />} Load report + verify
        </button>
        {data && (
          <button
            type="button"
            onClick={() => navigator.clipboard.writeText(text).then(() => toast.success("Copied"))}
            data-testid="launch-migration-copy-btn"
            className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-semibold bg-white/5 border border-white/10 text-slate-300 hover:bg-white/10 transition-colors"
          >
            <Copy size={12} /> Copy JSON
          </button>
        )}
      </div>
      {data && (
        <pre className="text-[10px] leading-snug text-slate-300 bg-black/40 rounded-lg p-3 max-h-96 overflow-auto" data-testid="launch-migration-report">
          {text}
        </pre>
      )}
    </div>
  );
}
